import * as authInterface from './authInterface';
import * as navigation from './navigation';
import { getEnvironment } from '../global/relayEnvironmnentProvider';
import * as promptTracker from './promptTracker';
import {
    conditionalMarkSuspectedTrade,
    currentUserCreatedDate,
    currentUserTradeStatus,
    eligibleToApplyForTrade,
    setTradeStatusToApplied,
    setUserName,
    setUserZipCode,
    whenUserFullyLoaded
} from './userHelpers';
import sendTradeAppToTfa from './sendTradeAppToTfa.es';

import 'dibs-auth-modal/dist/main.css';

const { authModalFlows } = authInterface;

//login flows that should not be followed by post-auth
const loginBlacklist = [
    authModalFlows.TRADE_APPLICATION_FLOW,
    authModalFlows.ALT_REGISTRATION_CONSUMER_FLOW,
    authModalFlows.ALT_REGISTRATION_TRADE_FLOW,
    authModalFlows.CONTACT_DEALER_FLOW,
    authModalFlows.CONTACT_DEALER_CALL_FLOW,
    authModalFlows.CONTACT_DEALER_FORM_FLOW,
    authModalFlows.MAKE_OFFER_FLOW
];

//registration flows that should not be followed by post-auth
const registrationBlacklist = [
    authModalFlows.TRADE_APPLICATION_FLOW,
    authModalFlows.ALT_REGISTRATION_CONSUMER_FLOW,
    authModalFlows.ALT_REGISTRATION_TRADE_FLOW,
    authModalFlows.CONTACT_DEALER_CALL_FLOW,
    authModalFlows.MAKE_OFFER_FLOW
];

const deferred = () => {
    let resolveRef;

    const promise = new Promise((resolve) => {
        resolveRef = resolve;
    });

    promise.resolve = resolveRef;
    return promise;
};

const postAuthDeferred = deferred();
let moduleLoaded = false;
let constants;

const loadPostAuthModule = function () {
    if (!moduleLoaded) {
        require.ensure('dibs-auth-modal', () => {
            const postAuth = require('dibs-auth-modal');
            postAuth.init(getEnvironment());
            constants = postAuth.publicConstants;
            postAuthDeferred.resolve(postAuth);
        }, 'dibs-auth-modal');
        moduleLoaded = true;
    }

    return postAuthDeferred;
};

const handlePostAuthCompletion = function ({ consumerZipCode, tradeApplicationData, firstName, lastName }) {
    promptTracker.markCompletedInLocalStorage();

    if (consumerZipCode) {
        setUserZipCode(consumerZipCode);
    }

    if (tradeApplicationData) {
        sendTradeAppToTfa(tradeApplicationData, constants.tfaTradeConfig)
            .then(setTradeStatusToApplied);
    }

    if (firstName && lastName) {
        setUserName(firstName, lastName);
    }
};

const handleUserTypeSelection = function (userType) {
    if (userType === constants.userTypes.TRADE) {
        conditionalMarkSuspectedTrade();
    }
};

export function autoPromptRegistration() {

    if (navigation.onTradeApplicationPage()) {
        return;
    }

    loadPostAuthModule().then(postAuth => {
        postAuth.init(getEnvironment());

        //open the post-auth modal
        const autoPromptRegister = postAuth.run('AUTO_PROMPT_REGISTER');

        autoPromptRegister.onUserTypeSelected((userType) => {
            if (userType === constants.userTypes.CONSUMER) {
                postAuth.hide();
                authInterface.consumerAltRegistration({ label: 'pageview limit reached' })
                    .then(({ newUser }) => {
                        if (newUser) {
                            postAuth.show();
                        }
                    });
            }
        });

        autoPromptRegister.onDealerApplicationClick(navigation.goToDealerApplication);

        autoPromptRegister.onLoginLinkClicked(() => {
            postAuth.hide();
            authInterface.basicLogin();
        });

        autoPromptRegister.onPostAuthCompleted(({ consumerZipCode, tradeApplicationData, tradeApplicationForced, firstName, lastName, email }) => {
            promptTracker.markCompletedInLocalStorage();

            if (consumerZipCode) {
                setUserZipCode(consumerZipCode);
            }

            if (tradeApplicationData) {
                postAuth.hide();

                //if user abandoned trade application, just send whatever data was provided
                if (tradeApplicationForced) {
                    sendTradeAppToTfa(tradeApplicationData, constants.tfaTradeConfig);
                } else {
                    authInterface.tradeAltRegistration({ label: 'pageview limit reached', email })
                        .then((authResult) => {
                            //if user abandoned authentication, just send trade application data
                            if (authResult.err) {
                                sendTradeAppToTfa(tradeApplicationData, constants.tfaTradeConfig);
                            } else {
                                whenUserFullyLoaded(() => {
                                    if (eligibleToApplyForTrade()) {
                                        sendTradeAppToTfa(tradeApplicationData, constants.tfaTradeConfig);
                                        setTradeStatusToApplied();
                                        postAuth.show();
                                    }

                                    if (firstName && lastName) {
                                        setUserName(firstName, lastName);
                                    }
                                });
                            }
                        });
                }
            }
        });
    });
};

export function postLogin({ environment, flow = '' }) {
    if (loginBlacklist.indexOf(flow) > -1 || navigation.onTradeApplicationPage()) {
        return;
    }

    whenUserFullyLoaded(() => {
        if (promptTracker.doPostAuthAtLogin(currentUserCreatedDate(), currentUserTradeStatus())) {
            loadPostAuthModule().then(postAuth => {
                postAuth.init(environment);
                postAuth.run('LOGIN', flow)
                    .onUserTypeSelected(handleUserTypeSelection)
                    .onDealerApplicationClick(navigation.goToDealerApplication)
                    .onPostAuthCompleted(handlePostAuthCompletion);

                postAuth.show();
            });

            promptTracker.incrementLoginPromptCount();
        }
    });
};

export function postRegistration({ environment, flow = '' }) {
    if (registrationBlacklist.indexOf(flow) > -1 || navigation.onTradeApplicationPage()) {
        return;
    }

    whenUserFullyLoaded(() => {
        loadPostAuthModule().then(postAuth => {
            postAuth.init(environment);
            postAuth.run('REGISTER', flow)
                .onUserTypeSelected(handleUserTypeSelection)
                .onDealerApplicationClick(navigation.goToDealerApplication)
                .onPostAuthCompleted(handlePostAuthCompletion);

            postAuth.show();
        });
    });
};



// WEBPACK FOOTER //
// ./assets/js/postAuth/postAuthLoader.es.js